export const BRAND = {
  orange: "#cc5500",
  orangeHover: "#E65A00",
  orangeLight: "rgba(255, 106, 0, 0.08)",
  navy: "#1A2B4A",
  navyDark: "#152238",
  text: "#374151",
  muted: "#6B7280",
  border: "#E5E7EB",
  bg: "#F8FAFC",
  success: "#16A34A",
  successHover: "#15803D",
};

export const LAYOUT = {
  headerHeight: 64,
  sidebarWidth: 240,
  cardRadius: "16px",
  cardShadow: "0 4px 24px rgba(0,0,0,0.06)",
  sidebar: {
    bg: BRAND.navy,
    bgDark: BRAND.navyDark,
    text: "rgba(255,255,255,0.72)",
    textHover: "#ffffff",
    hoverBg: "rgba(255,255,255,0.08)",
    activeBg: "rgba(255,106,0,0.15)",
    activeBorder: BRAND.orange,
  },
};

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#fff",
    transition: "box-shadow 0.2s, border-color 0.2s",
    "& fieldset": { borderColor: BRAND.border },
    "&:not(.MuiInputBase-multiline)": {
      height: 48,
    },
    "&:hover fieldset": { borderColor: "#CBD5E1" },
    "&.Mui-focused fieldset": {
      borderColor: BRAND.orange,
      borderWidth: "1.5px",
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 3px ${BRAND.orangeLight}`,
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "0.9375rem",
  },
  "& input::-ms-reveal, & input::-ms-clear": {
    display: "none",
  },
  "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    color: BRAND.muted,
    fontSize: "1.2rem",
  },
};

export const mobileInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    minHeight: 52,
  },
  "& .MuiInputBase-input": {
    fontSize: "16px",
    py: 1.5,
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.9375rem",
  },
};

export const primaryButtonSx = {
  bgcolor: BRAND.orange,
  color: "#fff",
  py: 1.5,
  borderRadius: "10px",
  fontWeight: 600,
  fontSize: "0.95rem",
  letterSpacing: "0.02em",
  textTransform: "none",
  transition: "background-color 0.2s, transform 0.15s, box-shadow 0.2s",
  "&:hover": {
    bgcolor: BRAND.orangeHover,
    boxShadow: "0 4px 14px rgba(255,106,0,0.35)",
  },
  "&:active": { transform: "scale(0.99)" },
  "&.Mui-disabled": {
    bgcolor: "#E5E7EB",
    color: BRAND.muted,
  },
};

export const backLinkSx = {
  color: BRAND.orange,
  fontWeight: 600,
  cursor: "pointer",
  border: "none",
  background: "none",
  fontFamily: "inherit",
  fontSize: "0.875rem",
};

export const otpInputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    width: 44,
    height: 52,
    "& input": {
      textAlign: "center",
      fontSize: "1.25rem",
      fontWeight: 600,
      padding: 0,
    },
    "& fieldset": { borderColor: BRAND.border },
    "&:hover fieldset": { borderColor: "#CBD5E1" },
    "&.Mui-focused fieldset": {
      borderColor: BRAND.orange,
      borderWidth: "1.5px",
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 3px ${BRAND.orangeLight}`,
    },
  },
};

export const toolbarButtonSx = {
  borderRadius: "10px",
  textTransform: "none",
  px: 2,
  height: "40px",
  fontSize: "0.875rem",
  fontWeight: 600,
  boxShadow: "none",
  "&:hover": {
    boxShadow: "0 4px 14px rgba(255,106,0,0.35)",
  },
};

export const dialogPaperSx = {
  borderRadius: "16px",
  border: `1px solid ${BRAND.border}`,
  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
};

export const dialogTitleSx = {
  color: BRAND.navy,
  fontWeight: 700,
  fontSize: "1.125rem",
  pb: 1,
};
